// extracted by css-extract-rspack-plugin
export default {"cls1":"SignupBanner-cls1_5VY","cls2":"SignupBanner-cls2_P5R SignupBanner-cls1_5VY"};